import React from 'react';
import { Outlet } from 'react-router-dom';
import AppConfig from '../../layout/AppConfig';

const FullPageLayout = () => {
    return (
        <React.Fragment>
            <Outlet />
            <AppConfig minimal />
        </React.Fragment>
    );
};

export default FullPageLayout;
